export const AI_ASSISTANT_DRAWER_MODAL_PROPS = { keepMounted: true };
